import { render, staticRenderFns } from "./PlantasOrnamentaisInstitucional.vue?vue&type=template&id=cd486858&"
import script from "./PlantasOrnamentaisInstitucional.vue?vue&type=script&lang=js&"
export * from "./PlantasOrnamentaisInstitucional.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports